import { render, staticRenderFns } from "./LogTab.vue?vue&type=template&id=fba6d8a8&scoped=true"
import script from "./LogTab.vue?vue&type=script&lang=js"
export * from "./LogTab.vue?vue&type=script&lang=js"
import style0 from "./LogTab.vue?vue&type=style&index=0&id=fba6d8a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba6d8a8",
  null
  
)

export default component.exports